import React from 'react';
import brisk4byteLogo from '../../assets/Brisk4Byte/brisk4byte.png';
import './PoweredBy.css';

const PoweredBy = () => {
    return (
        <a
            href="https://www.brisk4byte.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="powered-by-badge"
            aria-label="Powered by Brisk4Byte"
        >
            <span className="powered-by-text">Powered by</span>
            <div className="powered-by-logo">
                <img src={brisk4byteLogo} alt="Brisk4Byte" />
            </div>
        </a>
    );
};

export default PoweredBy;
